// @constants
const actionTypes = require('constants/actionTypes');
// @utilities
const Api = require('../services/api');
const apiURLBuilder = require('../core/apiURLBuilder');

const requestFeatureFlaggingStart = () => ({
    type: actionTypes.FEATURE_FLAGGING_FETCH_REQUEST,
});

const requestFeatureFlaggingSuccess = data => ({
    type: actionTypes.FEATURE_FLAGGING_REQUEST_SUCCESS,
    data,
});

const requestFeatureFlaggingFailure = () => ({
    type: actionTypes.FEATURE_FLAGGING_REQUEST_FAILURE,
});

const requestDataFeature = () => {
    return Api.get(apiURLBuilder.getURL('flags'))
        .then(response => ({ response, error: false }))
        .catch(response => ({ response, error: true }));
};

const requestFeatureFlagging = () => {
    return async dispatch => {
        dispatch(requestFeatureFlaggingStart());
        const response = await requestDataFeature();
        if (response && !response.error && response.response && response.response.body) {
            dispatch(requestFeatureFlaggingSuccess(response.response.body));
            return;
        }
        dispatch(requestFeatureFlaggingFailure());
    };
};

export default {
    requestFeatureFlagging,
};
